import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText,
    Toolbar, Typography, Divider, Chip, Avatar
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HistoryIcon from '@mui/icons-material/History';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import RadarIcon from '@mui/icons-material/Radar';
import { useAuth } from '../contexts/AuthContext';

const NAV_ITEMS = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
    { label: 'Nova Pesquisa', icon: <SearchIcon />, path: '/pesquisa' },
    { label: 'Listas de Compras', icon: <ShoppingCartIcon />, path: '/listas' },
    { label: 'Histórico', icon: <HistoryIcon />, path: '/historico' },
];

const ADMIN_ITEMS = [
    { label: 'Usuários', icon: <PeopleIcon />, path: '/usuarios' },
    { label: 'Configurações', icon: <SettingsIcon />, path: '/configuracoes' },
];

const SidebarContent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, tenant, isAdmin } = useAuth();

    const NavButton = ({ item }) => {
        const active = location.pathname === item.path;
        return (
            <ListItem disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                    onClick={() => navigate(item.path)}
                    sx={{
                        borderRadius: 2,
                        mx: 1,
                        bgcolor: active ? 'rgba(255,255,255,0.15)' : 'transparent',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                        color: '#fff'
                    }}
                >
                    <ListItemIcon sx={{ color: active ? '#fff' : 'rgba(255,255,255,0.7)', minWidth: 40 }}>
                        {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: active ? 600 : 400 }} />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', bgcolor: '#074960' }}>
            <Toolbar sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 2, gap: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <RadarIcon sx={{ color: '#fff', fontSize: 28 }} />
                    <Typography variant="h6" color="white" fontWeight={700}>Compras Radar</Typography>
                </Box>
                <Chip label={tenant?.name || 'Organização'} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontSize: '0.7rem', maxWidth: '90%' }} />
            </Toolbar>
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

            <List sx={{ flexGrow: 1, pt: 1 }}>
                {NAV_ITEMS.map(item => <NavButton key={item.path} item={item} />)}
                {isAdmin() && (
                    <>
                        <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)', my: 1, mx: 2 }} />
                        <ListItem sx={{ px: 2, py: 0 }}>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>Administração</Typography>
                        </ListItem>
                        {ADMIN_ITEMS.map(item => <NavButton key={item.path} item={item} />)}
                    </>
                )}
            </List>

            <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />
            <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 34, height: 34, fontSize: '0.875rem' }}>
                    {user?.name?.[0]?.toUpperCase()}
                </Avatar>
                <Box sx={{ overflow: 'hidden' }}>
                    <Typography variant="body2" color="white" fontWeight={600} noWrap>{user?.name}</Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                        {user?.role === 'admin' ? 'Administrador' : user?.role === 'analyst' ? 'Analista' : 'Visualizador'}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const Sidebar = ({ drawerWidth, mobileOpen, onClose, isMobile }) => (
    <Box component="nav" sx={{ width: isMobile ? 0 : drawerWidth, flexShrink: 0 }}>
        {isMobile ? (
            <Drawer variant="temporary" open={mobileOpen} onClose={onClose} ModalProps={{ keepMounted: true }} sx={{ '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', background: '#074960' } }}>
                <SidebarContent />
            </Drawer>
        ) : (
            <Drawer variant="permanent" sx={{ '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', background: '#074960', border: 'none', borderRadius: 0 } }} open>
                <SidebarContent />
            </Drawer>
        )}
    </Box>
);

export default Sidebar;
